import { apiClient } from '@/lib/api'

/**
 * Streets API - Districts, Streets, Subway
 */

// Districts
export const districtsApi = {
  getAll: (params = {}) => apiClient.get('/v1/streets/districts/', { params }),
  getAutocomplete: (params = {}) => apiClient.get('/v1/streets/districts/autocomplete/', { params }),
}

// Streets
export const streetsApi = {
  getAll: (params = {}) => apiClient.get('/v1/streets/streets/', { params }),
  getAutocomplete: (params = {}) => apiClient.get('/v1/streets/streets/autocomplete/', { params }),
}

// Subway
export const subwayApi = {
  getAll: (params = {}) => apiClient.get('/v1/streets/subway/', { params }),
  getAutocomplete: (params = {}) => apiClient.get('/v1/streets/subway/autocomplete/', { params }),
}
